import React, {
	useEffect,
	useState,
	useRef,
	useCallback,
	useMemo,
} from "react";

import { Link, useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setLoading, setModule } from "../../store/actions/commonAction";
import CommonDataService from "../../services/common";
import {
	AllowedUsergroup,
	GetIndexByValue,
	CDNWebsite,
	apiUrl,
} from "../../helpers/common";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Divider from "@mui/material/Divider";
import SaveIcon from "@mui/icons-material/Save";
import PhotoCamera from "@mui/icons-material/PhotoCamera";

import dayjs from "dayjs";
import JoditEditor from "jodit-react";
import MessageDialog from "../MessageDialog";
import http from "../../http";

export default function AddNews({ placeholder }) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	let { id } = useParams();
	const editor = useRef(null);

	const company = useSelector((state) => state.commonReducer.user.company);
	const userGroup = useSelector((state) => state.commonReducer.user.usergroup);
	const token = useSelector((state) => state.commonReducer.user.token);
	const loading = useSelector((state) => state.commonReducer.loading);

	const [message, setMessage] = useState("");
	const [error, setError] = useState(false);

	const [thumbPath, setThumbPath] = useState([]);
	const [offices, setOffices] = useState([]);
	const [categories, setCategories] = useState([]);
	const [idOffice, setIdOffice] = useState(company);
	const [idOfficeAC, setIdOfficeAC] = useState(null);
	const [title, setTitle] = useState("");
	const [keyword, setKeyword] = useState("");
	const [publishTime, setPublishTime] = useState(dayjs());
	const [active, setActive] = useState(true);
	const [headline, setHeadline] = useState(true);
	const [uniqueName, setUniqueName] = useState("");
	const [intro, setIntro] = useState("");
	const [newsCategoryId, setNewsCategoryId] = useState("");
	const [image, setImage] = useState("");
	const [content, setContent] = useState("");

	const LoadSelect = useCallback(() => {
		dispatch(setLoading(true));

		const searchParams = new URLSearchParams(document.location.search);

		switch (searchParams.get("source")) {
			case "aboutus":
				dispatch(setModule("About Us"));
				break;
			case "privacy":
				dispatch(setModule("Privacy"));
				break;
			case "legal":
				dispatch(setModule("Legal"));
				break;
			default:
				dispatch(setModule("News"));
		}

		CommonDataService.getNewsCategories().then((res) => {
			setCategories(res.data);
		});

		if (typeof id !== "undefined") {
			CommonDataService.getNewsById(id).then((res) => {
				setIdOffice(res.data.Row.id_office);
				setTitle(res.data.Row.title);
				setKeyword(res.data.Row.keyword);
				setPublishTime(dayjs(res.data.Row.publish_time));
				setActive(res.data.Row.active);
				setHeadline(res.data.Row.headline);
				setUniqueName(res.data.Row.unique_name);
				setIntro(res.data.Row.intro);
				setNewsCategoryId(res.data.Row.news_category_id);
				setContent(res.data.Row.content);
				setThumbPath(CDNWebsite() + res.data.Row.headline_thumb);

				dispatch(setLoading(false));
			});
		} else {
			dispatch(setLoading(false));
		}

		if (AllowedUsergroup(userGroup, "superuser-website")) {
			CommonDataService.getOffices().then((res) => {
				setOffices(res.data);
			});
		}
	}, [dispatch, id, userGroup]);

	useEffect(() => {
		setIdOfficeAC(GetIndexByValue(offices, idOffice));
	}, [offices, idOffice]);

	useEffect(() => {
		LoadSelect();
	}, [LoadSelect]);

	const handleSubmit = (event) => {
		event.preventDefault();

		const data = new FormData(event.currentTarget);

		if (typeof id === "undefined") {
			id = 0;
		}

		data.append("image", image);
		data.append("Id", id);
		data.append("IdOffice", idOffice);
		data.append("NewsCategoryId", newsCategoryId);
		data.append("Title", title);
		data.append("Keyword", keyword);
		data.append("Content", content);
		data.append(
			"PublishTime",
			dayjs(publishTime).format("YYYY-MM-DD HH:mm:ss")
		);
		data.append("Active", active);
		data.append("Headline", headline);
		data.append("UniqueName", uniqueName);
		data.append("Intro", intro);

		dispatch(setLoading(true));

		http
			.post("/news/save", data, {
				headers: {
					"Content-Type": "multipart/form-data",
					Authorization: "Bearer " + token,
				},
			})
			.then((res) => {
				dispatch(setLoading(false));
				navigate("/news/main" + window.location.search);
			})
			.catch(function (error) {
				setMessage(error.response.data.message);
				setError(true);
				dispatch(setLoading(false));
			});
	};

	const config = useMemo(() => {
		return {
			readonly: false,
			uploader: {
				url: apiUrl() + "/news/upload",
				headers: {
					Authorization: "Bearer " + token,
				},
			},
			imageDefaultWidth: "100%",
			placeholder: placeholder || "Start typings...",
		};
	}, [placeholder, token]);

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<MessageDialog show={error} message={message} dialogClose={setError} />

				<Paper
					sx={{
						p: 2,
						display: "flex",
						flexDirection: "column",
					}}
				>
					<Box component="form" onSubmit={(e) => handleSubmit(e)}>
						<Typography variant="h5">News Form</Typography>

						<Grid container spacing={3}>
							{AllowedUsergroup(userGroup, "superuser-website") && (
								<Grid item xs={12} sm={12}>
									<Autocomplete
										id="id_office"
										name="id_office"
										options={offices}
										getOptionLabel={(option) => option.name}
										isOptionEqualToValue={(option, value) =>
											option.value === value.value
										}
										fullWidth={true}
										onChange={(e, val) => {
											if (val !== null) {
												setIdOffice(val.id);
											} else {
												setIdOffice("");
											}
										}}
										value={idOfficeAC}
										sx={{ minWidth: 100 }}
										renderInput={(params) => (
											<TextField
												variant="standard"
												{...params}
												label="Office"
											/>
										)}
									/>
								</Grid>
							)}

							<Grid item xs={12} sm={12}>
								<div>
									<img alt="" height="100" src={thumbPath} />
								</div>
								<Button
									startIcon={<PhotoCamera />}
									variant="outlined"
									component="label"
								>
									Select Image
									<input
										hidden
										onChange={(e) => {
											setImage(e.target.files[0]);
											const file = e.target.files[0];
											let reader = new FileReader();
											reader.readAsDataURL(file);
											reader.onload = () => {
												setThumbPath(reader.result);
											};
										}}
										accept="image/*"
										multiple
										type="file"
									/>
								</Button>
							</Grid>

							<Grid item xs={12} sm={6}>
								<FormControl
									fullWidth={true}
									variant="standard"
									sx={{ minWidth: 100 }}
								>
									<InputLabel id="id-category-label">Category</InputLabel>
									<Select
										labelId="id-category-label"
										id="id_category"
										name="id_category"
										value={newsCategoryId}
										onChange={(e) => {
											setNewsCategoryId(e.target.value);
										}}
									>
										<MenuItem value="">
											<em>None</em>
										</MenuItem>
										{categories.map((option, index) => (
											<MenuItem key={index} value={option.id}>
												{option.name}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									required
									label="Title"
									id="title"
									name="title"
									value={title}
									fullWidth
									variant="standard"
									onChange={(e) => setTitle(e.target.value)}
								/>
							</Grid>

							{typeof id !== "undefined" && (
								<Grid item xs={12} sm={6}>
									<TextField
										required
										label="Unique Name"
										id="uniqueName"
										name="uniqueName"
										value={uniqueName}
										fullWidth
										variant="standard"
										onChange={(e) => setUniqueName(e.target.value)}
									/>
								</Grid>
							)}
							<Grid item xs={12} sm={6}>
								<TextField
									label="Keyword"
									id="keyword"
									name="keyword"
									value={keyword}
									fullWidth
									multiline
									rows={4}
									onChange={(e) => setKeyword(e.target.value)}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									label="Intro"
									fullWidth
									multiline
									rows={4}
									value={intro}
									onChange={(e) => setIntro(e.target.value)}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DateTimePicker
										label="Publish Time"
										value={publishTime}
										onChange={(e) => setPublishTime(dayjs(e))}
										renderInput={(params) => <TextField {...params} />}
									/>
								</LocalizationProvider>
							</Grid>

							<Grid item xs={12} sm={3}>
								<FormControlLabel
									control={
										<Checkbox
											checked={active === "true" || active === true}
											onChange={(e) => setActive(e.target.checked)}
										/>
									}
									label="Active"
								/>
							</Grid>

							<Grid item xs={12} sm={3}>
								<FormControlLabel
									control={
										<Checkbox
											checked={headline === "true" || headline === true}
											onChange={(e) => setHeadline(e.target.checked)}
										/>
									}
									label="Headline"
								/>
							</Grid>

							<Grid item xs={12} sm={12}>
								<JoditEditor
									ref={editor}
									value={content}
									config={config}
									tabIndex={1} // tabIndex of textarea
									onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
									onChange={(newContent) => {}}
								/>
							</Grid>

							<Grid item xs={12} sm={12}>
								<Divider />
							</Grid>

							<Grid item xs={12} sm={12}>
								<Button
									variant="contained"
									component={Link}
									to={"/news/main" + window.location.search}
									startIcon={<ArrowBackIcon />}
									sx={{ mr: 1 }}
								>
									Cancel
								</Button>
								<Button
									type="submit"
									variant="contained"
									disabled={loading}
									startIcon={<SaveIcon />}
								>
									{loading && (
										<span>
											<span className="spinner-border spinner-border-sm"></span>
											&nbsp;
										</span>
									)}
									<span> {loading ? "Please Wait" : "Save"}</span>
								</Button>
							</Grid>
						</Grid>
					</Box>
				</Paper>
			</Grid>
		</Grid>
	);
}
